import { put } from 'redux-saga/effects';

export function* addNotification({ newNotification }) {
  yield put({
    type: 'NOTIFICATION/ADD_NOTIFICATION',
    newNotification,
  });
}
